import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { BottomNavigationModalComponent } from './bottom-navigation-modal/bottom-navigation-modal.component';
import { BottomNavigationComponent } from './bottom-navigation/bottom-navigation.component';

@NgModule({
  declarations: [
    BottomNavigationComponent,
    BottomNavigationModalComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
  ],
  exports: [
    BottomNavigationComponent,
    BottomNavigationModalComponent,
  ],
})
export class ShellComponentsModule {}
